import React, { Component } from 'react';
import PeopleList from './PeopleList';

export default class PeopleSection extends Component {
  render() {
    const { data } = this.props;
    if (!data.people || data.people.length === 0) return null;

    let hasProfiles = false;
    for (let person of data.people) {
      if (!person.fn || !person.ln) {
        continue;
      }
      hasProfiles = true;
      // if (person.image || person.bio || person.prof) {
      //   hasProfiles = true;
      // }
    }

    if (!hasProfiles) {
      return null;
    }

    return (
      <div className="section">
        <h3 className="sectiontitle">
          {data.people.length > 1 ? 'People' : 'Meet the doctor'}
        </h3>
        <br />
        <div className="sectionitem" style={{ maxWidth: '850px' }}>
          <PeopleList p={data} verbose={true} />
        </div>
      </div>
    );
  }
}
